import {Checkbox as ChakraCheckbox, CheckboxControlProps, CheckboxIndicatorProps} from "@chakra-ui/react";
import * as React from "react";

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  icon?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  indicatorProps?: CheckboxIndicatorProps;
  controlProps?: CheckboxControlProps;
  rootRef?: React.Ref<HTMLLabelElement>;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
  const {icon, children, inputProps, controlProps, indicatorProps, rootRef, ...rest} = props;
  return (
    <ChakraCheckbox.Root ref={rootRef} {...rest}>
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control {...controlProps}>
        {icon || <ChakraCheckbox.Indicator {...indicatorProps} />}
      </ChakraCheckbox.Control>
      {children != null && <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>}
    </ChakraCheckbox.Root>
  );
});
